angular.module('eStories.paging.model', [

        /*eStories Paging Model*/

    ])
    .service('PagingModel', ['$rootScope', '$state', function ($rootScope, $state) {

        var model = this;

        model.updatePageNumber = function (currentState, pageNumber) {
            if (model.pagingData[currentState] == null) {
                model.pagingData[currentState] = {
                    pageNumber: pageNumber
                };
            } else {
                model.pagingData[currentState].pageNumber = pageNumber
            }
        };

        model.updateResultsData = function (currentState, totalCount) {
            model.pagingData[currentState].totalPageCount = model.getTotalPageCount(currentState, totalCount);
            model.pagingData[currentState].totalCount = model.getTotalResultsCount(currentState, totalCount);
        };

        model.globalPageSize = 40;

        model.getTotalPageCount = function (currentState, totalCount) {
                if (model.pagingData[currentState].totalPageCount != null) {
                    return model.pagingData[currentState].totalPageCount;
                }
                return Math.ceil(totalCount / model.globalPageSize);
        };

        model.getTotalResultsCount = function (currentState, totalCount) {
            if (model.pagingData[currentState].totalCount != null) {
                return model.pagingData[currentState].totalCount;
            } else {
                return totalCount != null ? totalCount : null
            }
        };

        model.pagingData = {};

        model.resetPagingData = function () {
            model.pagingData = {};
        };

        model.viewedPagesMap = {};

        model.preparePagination = function (pageNumber, pageSize, descending, countTotalResults, sortField) {
            var obj = {
                pageNumber: pageNumber,
                pageSize: pageSize ? pageSize : 40
            };

            if (descending != null) {
                obj.descending = descending;
            }

            if (countTotalResults != null) {
                obj.countTotalResults = countTotalResults;
            }

            if (sortField != null) {
                obj.sortField = sortField;
            }

            return obj;
        };
    }]);
